import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Divider,
  TimePicker,
  Radio,
  Input,
  Flex,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { getStockItems } from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import {
  addStockReconcillation,
  getStockReconcillationDetails,
  updateStockReconcillation,
} from '../../../network/stockReconcillation';
import ItemListReconcillation from './ItemListReconcillation';
import HeadingApp from '../../../hooks/HeadingApp';
import { AiOutlineReconciliation } from 'react-icons/ai';
const AddStockReconcillation = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [dataSource, setDataSource] = useState([{}]);
  const { mutate: onAddStockReconcillation } = useMutation({
    mutationKey: ['addStockReconcillation'],
    mutationFn: (body) =>
      edit ? updateStockReconcillation(body, id) : addStockReconcillation(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getStockReconcillation],
      });
      form.resetFields();
      navigate('/stock-reconcillation');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const { data: stockReconcillationDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getStockReconcillation, id],
    queryFn: () => getStockReconcillationDetails(id),
    enabled: !!edit,
  });
  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const { data: accounts } = useQuery({
    queryKey: [queryKeys.getAccountSearch],
    queryFn: () => getSearchApi('Account'),
    keepPreviousData: true,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (edit && stockReconcillationDetails) {
      setDataSource(
        stockReconcillationDetails?.data?.items?.length
          ? stockReconcillationDetails?.data?.items
          : [{}]
      );
      form.setFieldsValue({
        ...stockReconcillationDetails?.data,
        posting_date: dayjs(stockReconcillationDetails?.data?.posting_date),
        posting_time: dayjs(
          stockReconcillationDetails?.data?.posting_time,
          'HH:mm'
        ),
      });
    } else {
      form.resetFields();
    }
  }, [edit, stockReconcillationDetails, form]);
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockReconcillation({
      ...values,
      company: companyName,
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
      items: dataSource?.map((item) => ({ ...item })),
    });
  };
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.EditStockReconcillation : t.AddStockReconcillation}
        path="/stock-reconcillation"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.stockReconcillation}
        subTitle={edit ? t.EditStockReconcillation : t.AddStockReconcillation}
        icon={<AiOutlineReconciliation />}
      />
      <Card style={{ borderRadius: '0' }}>
        <Form
          form={form}
          name="add-stock-reconcillation"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            items: [{}],
          }}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="purpose"
                    label={t.purpose}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.purpose}
                      options={[
                        { value: 'Opening Stock ', label: t.openingStock },
                        {
                          value: 'Stock Reconciliation',
                          label: t.StockReconcillation,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current.endOf('d').valueOf() <
                        dayjs().endOf('d').valueOf()
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_time"
                    label={t.postingTime}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <TimePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingTime}
                      format="HH:mm"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    hidden={!edit}
                    name="difference_amount"
                    label={t.differenceAmount}
                  >
                    <Input
                      placeholder={t.differenceAmount}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.items}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        const currentItems = form.getFieldValue('items') || [];
                        form.setFieldsValue({
                          items: currentItems.map((item) => ({
                            ...item,
                            warehouse: value,
                          })),
                        });
                        setDataSource(
                          dataSource.map((item) => ({
                            ...item,
                            warehouse: value,
                          }))
                        );
                      }}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} className="items-form-add">
                  {/* <Form.List name="items" style={{ width: '100%' }}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <>
                      <Flex
                        key={key}
                        justify="space-between"
                        align="center"
                        gap="5px"
                        style={{
                        width: '100%',
                        }}
                      >
                        <Form.Item
                          name={[name, 'item_code']}
                          label={t.items}
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          {...restField}
                        >
                          <Select
                            placeholder={t.items}
                            style={{ width: '100%' }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? '')
                                .toLocaleLowerCase()
                                .includes(input.toLocaleLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              (optionA?.label ?? '')
                                .toLowerCase()
                                .localeCompare(
                                  (optionB?.label ?? '').toLowerCase()
                                )
                            }
                            popupMatchSelectWidth={false}
                            options={itemsList?.message?.items?.map((item) => ({
                              value: item?.name,
                              label: item?.item_name,
                            }))}
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name,"warehouse"]}
                          label={t.warehouse}
                          rules={[
                            {
                              required: true,
                            },
                          ]}
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          initialValue={form.getFieldValue('set_warehouse')}
                        >
                        <Select
                          placeholder={t.warehouse}
                          style={{ width: '100%' }}
                          popupMatchSelectWidth={false}
                          onChange={(value, option) => {
                            console.log(option, 'option');
                          }}
                          options={warehouse?.data?.map((item) => ({
                            value: item?.name,
                            label: item?.warehouse_name,
                            option: item
                          }))}
                          // disabled
                        />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'qty']}
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          {...restField}
                          label={t.quantity}
                        >
                          <Input
                            placeholder={t.quantity}
                            style={{ width: '100%' }}
                            type="number"
                          />
                        </Form.Item>
                        <Form.Item
                          name={[name, 'valuation_rate']}
                          style={{
                            width: '100%',
                            marginBottom: '0px',
                          }}
                          {...restField}
                          label={t.valuationRate}
                        >
                          <Input
                            placeholder={t.valuationRate}
                            style={{ width: '100%' }}
                            type="number"
                          />
                        </Form.Item>
                       <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '15px',
                              margin: '0 10px',
                            }}
                          >
                            {fields.length > 1 && (
                              <Button
                                type="text"
                                onClick={() => remove(name)}
                                danger
                                icon={<MdDelete color="red" />}
                              />
                            )}
                            <Button
                              type="text"
                              onClick={() => add()}
                              icon={<PlusOutlined color="#1890ff" />}
                            />
                          </div>
                      </Flex>
                      </>
                    ))}
                  </>
                )}
              </Form.List> */}
                  <ItemListReconcillation
                    t={t}
                    form={form}
                    setDataSource={setDataSource}
                    dataSource={dataSource}
                    // itemsList={itemsList}
                    warehouse={warehouse}
                  />
                </Col>
                <Divider orientation="left">{t.Account}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="expense_account"
                    label={t.expenseAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.expenseAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={accounts?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="cost_center" label={t.costCenter}>
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddStockReconcillation;
